interface IProductOptionValue {
  value: string
  displayType: ProductOptionDisplayType
  displayName?: string
  hexCode?: string | undefined
  imgURL?: string | undefined | null
  addBorder?: boolean | undefined | null
  quantityInPack?: number | undefined
  maxCharacterLimit?: number | undefined
  minCharacterLimit?: number | undefined
  appExclusive?: boolean | undefined
  atcDisabled?: boolean | undefined
}

export default class ProductOptionValue implements IProductOptionValue {
  readonly value: string
  readonly displayType: ProductOptionDisplayType
  readonly displayName?: string | undefined = undefined
  readonly hexCode?: string | undefined = undefined
  readonly imgURL?: string | undefined | null = undefined
  readonly addBorder?: boolean | undefined | null = undefined
  readonly quantityInPack?: number | undefined = undefined
  readonly maxCharacterLimit?: number | undefined = undefined
  readonly minCharacterLimit?: number | undefined = undefined
  readonly appExclusive?: boolean | undefined = undefined
  readonly atcDisabled?: boolean | undefined

  constructor({
    value,
    displayType,
    displayName = undefined,
    hexCode = undefined,
    imgURL = undefined,
    addBorder = undefined,
    quantityInPack = undefined,
    maxCharacterLimit = undefined,
    minCharacterLimit = undefined,
    appExclusive = undefined,
    atcDisabled = undefined,
  }: IProductOptionValue) {
    this.value = value
    this.hexCode = hexCode
    this.imgURL = imgURL
    this.addBorder = addBorder
    this.displayType = displayType
    this.displayName = displayName
    this.quantityInPack = quantityInPack
    this.maxCharacterLimit = maxCharacterLimit
    this.minCharacterLimit = minCharacterLimit
    this.appExclusive = appExclusive
    this.atcDisabled = atcDisabled
    return {
      ...this,
    }
  }
}

interface IProductOption {
  readonly name: ProductOptionName
  readonly displayName: string
  readonly values?: ProductOptionValue[]
  readonly displaySequence: number
  readonly displayType?: string
  readonly isHidden?: boolean
  readonly isCustomOption?: boolean | undefined | null
  readonly maxCharacterLimit?: number
  readonly minCharacterLimit?: number
  readonly appExclusive?: boolean | undefined
  readonly atcDisabled?: boolean | undefined
}

export class ProductOption implements IProductOption {
  readonly name: ProductOptionName
  readonly displayName: string
  readonly values?: ProductOptionValue[]
  readonly displaySequence: number
  readonly displayType?: string | undefined
  readonly isCustomOption?: boolean | undefined | null
  readonly isHidden?: boolean | undefined
  readonly maxCharacterLimit?: number
  readonly minCharacterLimit?: number
  readonly appExclusive?: boolean | undefined
  readonly atcDisabled?: boolean | undefined

  constructor({
    name,
    displayName,
    values,
    displaySequence,
    displayType,
    isHidden,
    isCustomOption,
    maxCharacterLimit,
    minCharacterLimit,
    appExclusive,
    atcDisabled,
  }: IProductOption) {
    this.name = name
    this.displayName = displayName
    this.values = values
    this.displaySequence = displaySequence
    this.displayType = displayType
    this.isHidden = isHidden
    this.isCustomOption = isCustomOption
    this.maxCharacterLimit = maxCharacterLimit
    this.minCharacterLimit = minCharacterLimit
    this.appExclusive = appExclusive
    this.atcDisabled = atcDisabled
    return {
      ...this,
    }
  }
}

export enum ProductOptionName {
  Color = 'Color',
  Size = 'Size',
  Customization = 'Customization',
  Engraving = 'Engraving',
  Inseam = 'Inseam',
}

export enum ProductOptionDisplayType {
  COLOR = 'Color',
  TEXT = 'Text',
  IMAGE = 'Image',
  INPUT = 'Text_box',
  DEPRECATED_INPUT = 'DeprecatedInput',
  PACK = 'Pack',
}
